import { createFileRoute } from "@tanstack/react-router"
import ProjectTypePage from "@/components/project-type.tsx"
import { requireAuth } from "@/lib/route-guards"

export const Route = createFileRoute("/_authenticated/project-types")({
    beforeLoad: requireAuth, // eğer login kontrolü varsa
    component: ProjectTypePage,
})


